import { render, staticRenderFns } from "./IssueButton.vue?vue&type=template&id=f22f2c96&scoped=true&lang=pug"
import script from "./IssueButton.vue?vue&type=script&lang=js"
export * from "./IssueButton.vue?vue&type=script&lang=js"
import style0 from "./IssueButton.vue?vue&type=style&index=0&id=f22f2c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22f2c96",
  null
  
)

export default component.exports